module.exports = __webpack_public_path__ + "static/hill_giant-325a23c13473567500bd2501326cb648.jpeg";